import { getApp } from 'firebase/app';

const CHAT_DATABASE_ID = 'chat';
const AUTH_DB_NAME = 'firebaseLocalStorageDb';

let sdkPromise = null;

const initChatAuth = (authSdk, app) => {
	try {
		return authSdk.initializeAuth(app, { persistence: authSdk.indexedDBLocalPersistence });
	} catch (error) {
		if (error?.code === 'auth/already-initialized') {
			return authSdk.getAuth(app);
		}
		throw error;
	}
};

export const loadChatSdk = () => {
	if (!sdkPromise) {
		sdkPromise = Promise.all([
			import(/* webpackChunkName: "firebase-chat" */ 'firebase/auth'),
			import(/* webpackChunkName: "firebase-chat" */ 'firebase/firestore'),
		]).then(([authSdk, firestoreSdk]) => {
			const app = getApp();
			return {
				authSdk,
				firestoreSdk,
				auth: initChatAuth(authSdk, app),
				db: firestoreSdk.getFirestore(app, CHAT_DATABASE_ID),
			};
		});
		sdkPromise.catch(() => {
			sdkPromise = null;
		});
	}
	return sdkPromise;
};

export const chatAuthMayExist = () =>
	sdkPromise || typeof indexedDB === 'undefined' || typeof indexedDB.databases !== 'function'
		? Promise.resolve(true)
		: indexedDB.databases().then(
				(databases) => databases.some(({ name }) => name === AUTH_DB_NAME),
				() => true
		  );
